import React, { useState, useRef, useEffect, useCallback } from "react";
import {
  Button,
  Form,
  Input
} from "semantic-ui-react";
import {
  Container,
  Title
} from "./styles";

import { Link } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";
import CertificateEditor from "../../../../../components/Admin/Certificado/CertificateEditor";
import { producaov2 as api } from "../../../../../services/apis";
import swal from "sweetalert";
import * as yup from "yup";

import { systemLogs } from "../../../../../services/system_logs";

const CriarCertificado = () => {
  const [certificado, setCertificado] = useState({
    title: "",
    qrcode_color: "#ffffff",
    fonte: "monserrat",
    qrcode_dim: "300x300",
    qrcode_loc: "26.50,17.82,27.05,2.05",
    nome_loc: "1.32,9.00,27.05,2.05",
    iconcurso_loc: "23.55,17.75,2.38,2.33",
    assinaturavoitto_loc: "5.02,15.63,7.12,1.58",
    assinaturaconsultor_loc: "17.85,15.68,7.12,1.58",
    descricao_loc: "2.19,11.10,25.63,1.89",
    fundo_loc: "0.00,0.00,29.57,20.86",
    fundo: "",
    cert_w: "29.7",
    cert_h: "21",
  });

  const [imagemFundo, setImagemFundo] = useState(null);

  const handleCertificado = useCallback(
    (e) => {
      const { value, name } = e.target;
      const newCertificado = { ...certificado };
      newCertificado[name] = value;
      setCertificado(newCertificado);
    },
    [certificado]
  );

  const handleImagemFundo = useCallback(() => {
    if (
      certificado.fundo &&
      certificado.fundo !== imagemFundo &&
      typeof certificado.fundo !== "string"
    ) {
      setImagemFundo(certificado.fundo);
    }
  }, [certificado?.fundo, imagemFundo]);

  useEffect(() => {
    handleImagemFundo();
  }, [certificado?.fundo]);

  const handleSubmit = useCallback(
    async (e) => {
      try {
        e.preventDefault();

        const certificadoSchema = yup.object().shape({
          title: yup
            .string("Por gentileza, insira um título válido")
            .required("Por gentileza, insira um título"),
          qrcode_color: yup
            .string("Por gentileza, insira uma cor válida")
            .required("Por gentileza, insira uma cor válida"),
          fonte: yup
            .string("Por gentileza, insira uma fonte válida")
            .required("Por gentileza, insira uma fonte"),
          qrcode_dim: yup
            .string("Por gentileza, insira um QR Code DIM válido")
            .required("Por gentileza, insira um QR Code DIM"),
          qrcode_loc: yup
            .string("Por gentileza, insira um QRCode válido")
            .required("Por gentileza, insira um QRCode"),
          nome_loc: yup
            .string("Por gentileza, insira um nome válido")
            .required("Por gentileza, insira um nome"),
          iconcurso_loc: yup
            .string("Por gentileza, insira um icon de curso válido")
            .required("Por gentileza, insira um icon de curso"),
          assinaturavoitto_loc: yup
            .string("Por gentileza, insira um assinatura da Voitto válida")
            .required("Por gentileza, insira um assinatura da Voitto"),
          assinaturaconsultor_loc: yup
            .string("Por gentileza, insira um assinatura do consultor válida")
            .required("Por gentileza, insira um assinatura do consultor"),
          descricao_loc: yup
            .string("Por gentileza, insira um descrição válida")
            .required("Por gentileza, insira um descrição"),
          fundo_loc: yup
            .string("Por gentileza, insira um título válido")
            .required("Por gentileza, insira um título"),
          fundo: yup.string(),
          cert_w: yup.string().required("Por gentileza, insira um título"),
          cert_h: yup.string().required("Por gentileza, insira um título"),
        });

        await certificadoSchema.validate(certificado, { abortEarly: true });

        const data = new FormData();
        data.append("file", imagemFundo);
        data.append("nome", `${new Date().toISOString()}modelo_certificado`);
        data.append("path", "imagens-voitto");

        const uploadedImage = (await api.post("upload", data)).data;

        const payload = { ...certificado, fundo: uploadedImage.url };

        const modelo = (await api.post("layout-certificados", payload)).data;

        await systemLogs(
          "ead/certificado",
          `criou o modelo de certificado de id=${modelo.id}`
        );

        swal("Sucesso !", "Modelo de certificados foi criado", "success").then(
          (res) => {
            window.location.href = "/admin/ead/certificados";
          }
        );

        setCertificado(payload);
      } catch (err) {
        if (err instanceof yup.ValidationError) {
          swal("Ops !", `${err}`.replace("ValidationError:", ""), "error");
          return;
        }

        swal(
          "Ops !",
          "Houve um erro ao salvar a imagem de seu certificado",
          "error"
        );
      }
    },
    [certificado, imagemFundo]
  );

  return (
    <>
      <AdminMenu />
      <Container>
        <Title>Criar modelo de certificado</Title>

        <Form>
          <Form.Group widths="equal">
            <Form.Field>
              <label>Titulo do modelo</label>
              <Input
                placeholder="Titulo do modelo"
                name="title"
                value={certificado.title}
                onChange={handleCertificado}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.Field>
              <label>Cor QRCODE</label>
              <input
                type="color"
                name="qrcode_color"
                value={certificado.qrcode_color}
                onChange={handleCertificado}
              />
            </Form.Field>
          </Form.Group>
          <Form.Field>
            <label>Fonte</label>
            <input
              name="fonte"
              value={certificado.fonte}
              onChange={handleCertificado}
            />
          </Form.Field>
          <Form.Field>
            <label>Largura (cm)</label>
            <input
              type="number"
              name="cert_w"
              value={certificado.cert_w}
              onChange={handleCertificado}
            />
          </Form.Field>
          <Form.Field>
            <label>Altura (cm)</label>
            <input
              type="number"
              name="cert_h"
              value={certificado.cert_h}
              onChange={handleCertificado}
            />
          </Form.Field>

          <CertificateEditor
            certificado={certificado}
            setCertificado={setCertificado}
          />

          <Form.Group>
            <Form.Field>
              <Button onClick={handleSubmit}>Salvar</Button>
            </Form.Field>
            <Link to="/admin/ead/certificados">
              <Button color="secondary">Cancelar</Button>
            </Link>
          </Form.Group>
        </Form>
      </Container>
    </>
  );
};

export default CriarCertificado;
